module.exports = __webpack_public_path__ + "static/img/sample_01.7c5267c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sample_01.jpg
// module id = 57aP
// module chunks = 1